const SalesPrediction = [
  {
    path: '/sales-prediction',
    name: 'sales-prediction',
    component: () => import(/* webpackChunkName: "prediction" */'./views/SalesPrediction.vue'),
    meta: {
      requiresAuth: true,
      title: 'AlgoStack Analytics SalesPrediction',
    },
    children: [],
  },
];

export default SalesPrediction;
